import { FC } from 'react';
import Image from 'next/image';
import ElectionLogo from '~public/img/election-logo.png';
import SafeHTML from '../SafeHTML/SafeHTML';

export interface Props {
    title: string;
    testId?: string;
    extendedClassName?: string;
    electionLogoUrl: string;
}

const Heading: FC<Props> = (props: Props) => {
    const { title, testId, extendedClassName, electionLogoUrl } = props;

    return (
        <div className={`election-heading mb-[30px] mt-[10px] flex items-center gap-[15px]`} data-test-id={testId}>
            <div className="heading-box basis-[85%] text-left">
                <SafeHTML tag="h2" className={`heading m-0 md:text-[2em] ${extendedClassName}`} html={title} />
            </div>
            <div className="image-box inline-block basis-[15%] text-right">
                {electionLogoUrl && (
                    <img src={electionLogoUrl} alt="Coop valget" className="inline-block max-h-[170px] max-w-full" />
                )}
                {!electionLogoUrl && (
                    <Image src={ElectionLogo} alt="Coop valget" className="inline-block max-h-[170px] max-w-full" />
                )}
            </div>
        </div>
    );
};

export default Heading;
